import { parse } from "../utilities/helpers";

export default function Redirect({ page }) {
  const url = parse(page.buttonlink1, {});
  window.location.href = url.link || "/";
  return null;
}
